import { useNavigate } from "react-router-dom";

export const useNavigationHook = () => {
    const navigation = useNavigate();

    const navigateTo = (path: string) => {
        navigation(path);
    };

    return {
        navigateTo,
    };
};